import { render, staticRenderFns } from "./FormBsn.vue?vue&type=template&id=4de75126&scoped=true&"
import script from "./FormBsn.vue?vue&type=script&lang=js&"
export * from "./FormBsn.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./FormBsn.vue?vue&type=style&index=1&id=4de75126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de75126",
  null
  
)

export default component.exports